module.exports = __webpack_public_path__ + "img/Naeem.7f4c77e0.jpg";